goog.provide("shadow.js.shim.module$$embedpdf$plugin_stage");
goog.provide("module$shadow_js_shim_module$$embedpdf$plugin_stage");
shadow.js.shim.module$$embedpdf$plugin_stage = shadow.js.nativeProvides["@embedpdf/plugin-stage"] = shadow$bridge("@embedpdf/plugin-stage");
module$shadow_js_shim_module$$embedpdf$plugin_stage.default = shadow.js.shim.module$$embedpdf$plugin_stage;
